import styled from "styled-components";

export const Container = styled.div`
    position: relative;
    display: inline-block;
`;

export const Trigger = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    min-width: 150px;
    padding: 5px 10px;
    border: 1px solid #D8DEE9;
    border-radius: 8px;
    background: #FFFFFF;
    color: #6B7280;
    font-family: Mulish;
    font-size: 0.8rem;
    cursor: pointer;

    svg {
        font-size: 0.7rem;
    }
`;

export const Menu = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    min-width: 220px;
    max-height: 280px;
    overflow-y: auto;
    z-index: 20;
    padding: 4px;
    background: #FFFFFF;
    border: 1px solid #E6E9EF;
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
`;

export const Item = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
    padding: 8px 10px;
    border: none;
    border-radius: 6px;
    text-align: left;
    font-family: Mulish;
    font-size: 0.82rem;
    cursor: pointer;
    background: ${(props) => (props.$active ? "#E8F1FF" : "transparent")};
    color: ${(props) => (props.$active ? "#2F80ED" : "#3C4657")};
    font-weight: ${(props) => (props.$active ? 700 : 500)};

    &:hover {
        background: ${(props) => (props.$active ? "#E8F1FF" : "#F3F7FF")};
    }
`;

export const ItemName = styled.span`
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Message = styled.div`
    padding: 10px;
    text-align: center;
    color: #8A94A6;
    font-family: Mulish;
    font-size: 0.82rem;
`;
